import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";

const filter = createFilterOptions();

const QTDetailsAutoCompleteWithLabelSection = ({
  label,
  value,
  onChange,
  disabled,
  optionsData,
  editEnabled,
  error,
}) => {
  // Sort options alphabetically handling users (firstName/lastName) and custom narrators (name/fullName)
  const sortedOptions = optionsData ? [...optionsData].sort((a, b) => {
    // For users with firstName/lastName, construct full name
    const nameA = a.firstName && a.lastName 
      ? `${a.firstName} ${a.lastName}`.toLowerCase().trim()
      : (a.name || a.fullName || '').toLowerCase().trim();
    const nameB = b.firstName && b.lastName 
      ? `${b.firstName} ${b.lastName}`.toLowerCase().trim()
      : (b.name || b.fullName || '').toLowerCase().trim();
    return nameA.localeCompare(nameB);
  }) : [];

  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 24 }}>
      <span style={titleTextStyle}>{label}</span>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            onChange({
              fullName: newValue,
              id: null,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            onChange({
              fullName: newValue.inputValue,
              id: null,
            });
          } else {
            onChange(newValue || {});
          }
        }}
        onInputChange={(event, newInputValue, reason) => {
          // Log for debugging
          console.log("Input change: ", newInputValue, " Reason: ", reason);

          if (reason === "input") {
            onChange({ fullName: newInputValue, id: null });
          }
        }}
        // onChange={(event, newValue) => {
        //   if (typeof newValue === "string") {
        //     onChange({
        //       fullName: newValue,
        //       id: null,
        //     });
        //   } else if (newValue && newValue.inputValue) {
        //     // Create a new value from the user input
        //     onChange({
        //       fullName: newValue.inputValue,
        //       id: null,
        //     });
        //   } else {
        //     onChange(newValue);
        //   }
        // }}
        // onInputChange={(event, newInputValue) => {
        //     if (!newInputValue) return;
        //     onChange({ fullName: newInputValue, id: null });
        //   }}
        filterOptions={(options, params) => {
          const { inputValue } = params;

          // If no input, return all options
          if (!inputValue) return options;

          // Filter options based on case-insensitive match from the beginning of the name
          return options.filter(option => {
            let searchText = '';

            if (option.firstName && option.lastName) {
              searchText = `${option.firstName} ${option.lastName}`;
            } else if (option.name) {
              searchText = option.name;
            } else {
              searchText = option.fullName || '';
            }

            return searchText.toLowerCase().startsWith(inputValue.toLowerCase());
          });
        }}
        style={{
          width: "70%",
          color: "black",
        }}
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000",
          },
          color: "black",
        }}
        selectOnFocus
        clearOnBlur={false}
        handleHomeEndKeys
        // id="free-solo-with-text-demo"
        options={sortedOptions}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option - handle both users and organizations
          if (option.firstName && option.lastName) {
            const displayName = `${option.firstName} ${option.lastName}`;
            return option.userName ? `${displayName}/@${option.userName}` : displayName;
          }
          // Handle organizations with name field
          if (option.name) {
            return option.name;
          }
          return option.fullName || option.id || "";
        }}
        renderOption={(props, option) => (
          <li {...props}>
            {option.firstName && option.lastName
              ? (() => {
                  const displayName = `${option.firstName} ${option.lastName}`;
                  return option.userName ? `${displayName}/@${option.userName}` : displayName;
                })()
              : option.name || option.fullName}
          </li>
        )}
        disabled={editEnabled ? false : disabled}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            // label={label}
            placeholder={label}
            // disabled={editEnabled ? false : disabled}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000",
              },
            }}
            InputProps={{
              ...params.InputProps,
              //   type: "search",
              sx: {
                ...textfieldSXStyles,
                backgroundColor: editEnabled ? "#D2D2D2" : "#FFFFFF",
                outline: error ? "2px solid red" : "none",
              },
            }}
          />
        )}
      />
    </Grid>
  );
};

export default QTDetailsAutoCompleteWithLabelSection;

const titleTextStyle = {
  width: "25%",
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

const textfieldSXStyles = {
  border: "none",
  borderColor: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
